import { Link } from "react-router-dom";
import { Droplets, ArrowRight } from "lucide-react";
import { clusterEntry, clusterSiblings } from "@/lib/rainwaterCluster";

/**
 * Rainwater Guides cluster block + Tank 360 CTA.
 * Renders nothing for articles outside the rainwater cluster.
 */
export const RainwaterCluster = ({ slug }) => {
  const entry = clusterEntry(slug);
  if (!entry) return null;
  const siblings = clusterSiblings(slug);

  return (
    <section className="mt-10" data-testid="rainwater-cluster">
      <div className="rounded-2xl border border-cyan-200 bg-cyan-50/60 p-6">
        <div className="flex items-center gap-2">
          <Droplets className="w-4 h-4 text-cyan-700" />
          <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-cyan-800">
            Rainwater testing
          </span>
        </div>
        <p className="mt-3 text-base text-slate-700">{entry.cta.lead}</p>
        <Link
          to="/aware-tank-360"
          data-testid="rainwater-cluster-tank-cta"
          className="mt-4 inline-flex items-center gap-2 rounded-full bg-slate-900 hover:bg-slate-800 text-white font-semibold px-5 py-3 text-sm transition-colors"
        >
          {entry.cta.anchor} <ArrowRight className="w-4 h-4" />
        </Link>
        <p className="mt-3 text-xs text-slate-600">
          Sample kits posted Australia-wide · local drop-off at our Noosaville lab
        </p>
      </div>

      <div className="mt-6">
        <h2 className="text-base md:text-lg font-display font-bold text-slate-900">
          Rainwater guides
        </h2>
        <ul className="mt-3 grid sm:grid-cols-2 gap-2.5">
          {siblings.map((a) => (
            <li key={a.slug}>
              <Link
                to={`/blog/${a.slug}`}
                data-testid={`rainwater-cluster-link-${a.slug}`}
                className="flex items-start gap-2 rounded-xl border border-slate-200 bg-white p-3.5 text-sm text-slate-800 hover:border-cyan-400 hover:text-cyan-800 transition-colors"
              >
                <ArrowRight className="w-3.5 h-3.5 mt-1 flex-shrink-0 text-cyan-600" />
                <span>{a.label}</span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default RainwaterCluster;
